import { Box, Typography } from '@mui/material'
import BenchmarkReport from 'containers/dashboard/benchmarkReport/BenchmarkReport'
import { useParams } from 'react-router-dom'

export default function BenchmarkReportPage() {
  const { id } = useParams<{ id: string }>()

  if (!id) return <></>

  return (
    <Box m={4}>
      <Typography variant="h3" mb={4}>
        Benchmark Report
      </Typography>
      <BenchmarkReport id={id} showExtended />
    </Box>
  )
}
